import {IconButton} from "@chakra-ui/react";
import {IoArrowBackCircleOutline} from "@onemind-services-llc/react-icons-ng/io5";
import {navigateBack} from "../../utils/navigateBack";
import {BackButtonProps} from "./backButton.types";

export const BackButton = (props: BackButtonProps) => {
  const {icon = <IoArrowBackCircleOutline />, size = "lg", ...rest} = props;

  return <IconButton id="back-button" aria-label="back-button-aria" onClick={navigateBack} icon={icon} variant="back-btn" size={size} {...rest} />;
};
